import React, { useMemo } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  IconButton,
  Divider,
  Card,
  CardActionArea,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import BoltIcon from "@mui/icons-material/Bolt";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import LinkIcon from "@mui/icons-material/Link";
import PaymentsIcon from "@mui/icons-material/Payments";

const GLASS = {
  bg: "linear-gradient(135deg, rgba(18,22,28,.96) 0%, rgba(10,13,17,.92) 100%)",
  border: "1px solid rgba(255,255,255,.10)",
  text: "#e5e7eb",
  subtext: "#9ca3af",
};

const rowCardSx = {
  borderRadius: 2,
  border: "1px solid rgba(148,163,184,.18)",
  background: "rgba(15,23,42,.55)",
  overflow: "hidden",
};

function fmtUsd(v) {
  const n = Number(v || 0);
  return `$${n.toFixed(2)}`;
}

function shortAddr(a) {
  if (!a) return "";
  const s = String(a);
  return s.length > 10 ? `${s.slice(0, 6)}…${s.slice(-4)}` : s;
}

export default function DepositWithdrawModal({
  open,
  mode = "deposit",
  onClose,
  portfolioBalanceUsd = 0,
  walletAddress = "",
  walletUsdHint = "",
  onPick = (id) => console.log("pick", id),
}) {
  const title = mode === "withdraw" ? "Withdraw" : "Deposit";

  const options = useMemo(() => {
    if (mode === "withdraw") {
      return [
        { id: "wallet_withdraw", icon: <AccountBalanceWalletIcon fontSize="small" />, title: "To Wallet", sub: "Instant" },
        
      ];
    }

    return [
      { id: "wallet_deposit", icon: <AccountBalanceWalletIcon fontSize="small" />, title: `Wallet (${shortAddr(walletAddress) || "not connected"})`, sub: walletUsdHint || "Instant" },
      { id: "transfer_crypto", icon: <BoltIcon fontSize="small" />, title: "Transfer Crypto", sub: "No limit • Instant" },
      { id: "card", icon: <CreditCardIcon fontSize="small" />, title: "Deposit with Card", sub: "$50,000 • 5 min" },
      
    ];
  }, [mode, walletAddress, walletUsdHint]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          background: GLASS.bg,
          border: GLASS.border,
          color: GLASS.text,
          boxShadow: "0 24px 70px rgba(0,0,0,.55)",
          overflow: "hidden",
        },
      }}
    >
      <Box sx={{ px: 2.2, pt: 1.8, pb: 1.2, display: "flex", alignItems: "center" }}>
        <Box sx={{ minWidth: 0 }}>
          <Typography sx={{ fontWeight: 950, fontSize: 18, lineHeight: 1.2 }}>
            {title}
          </Typography>
          <Typography sx={{ color: GLASS.subtext, fontSize: 12, mt: 0.3 }}>
            Portfolio Balance: {fmtUsd(portfolioBalanceUsd)}
          </Typography>
        </Box>

        <IconButton onClick={onClose} sx={{ ml: "auto", color: "#cbd5e1" }}>
          <CloseIcon />
        </IconButton>
      </Box>

      <Divider sx={{ borderColor: "rgba(148,163,184,.16)" }} />

      <DialogContent sx={{ px: 2.2, py: 1.8 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
          {options.map((opt, idx) => {
            const showMoreDivider = mode === "deposit" && idx === 1;

            return (
              <React.Fragment key={opt.id}>
                {showMoreDivider && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, my: 0.2 }}>
                    <Divider sx={{ flex: 1, borderColor: "rgba(148,163,184,.14)" }} />
                    <Typography sx={{ color: GLASS.subtext, fontSize: 12 }}>more</Typography>
                    <Divider sx={{ flex: 1, borderColor: "rgba(148,163,184,.14)" }} />
                  </Box>
                )}

                <Card elevation={0} sx={rowCardSx}>
                  <CardActionArea
                    onClick={() => onPick(opt.id)}
                    sx={{
                      px: 1.6,
                      py: 1.4,
                      display: "flex",
                      alignItems: "center",
                      gap: 1.2,

                      // ВОТ ЭТО ВАЖНО: теперь иконки наследуют белый
                      color: GLASS.text,
                    }}
                  >
                    <Box
                      sx={{
                        width: 34,
                        height: 34,
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        border: "1px solid rgba(255,255,255,.10)",
                        background: "rgba(2,6,23,.55)",
                        color: GLASS.text, // на всякий случай
                      }}
                    >
                      {opt.icon}
                    </Box>

                    <Box sx={{ minWidth: 0, flex: 1 }}>
                      <Typography sx={{ fontWeight: 900, fontSize: 13, color: GLASS.text }}>
                        {opt.title}
                      </Typography>
                      <Typography sx={{ fontSize: 12, color: GLASS.subtext, mt: 0.2 }}>
                        {opt.sub}
                      </Typography>
                    </Box>
                  </CardActionArea>
                </Card>
              </React.Fragment>
            );
          })}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
